import { render, staticRenderFns } from "./turn-cases-apply.vue?vue&type=template&id=eb251fd4"
import script from "./turn-cases-apply.vue?vue&type=script&lang=ts"
export * from "./turn-cases-apply.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports